import { ProductInfo } from "@insite/client-framework/Common/ProductInfo";
import { SafeDictionary } from "@insite/client-framework/Common/Types";
import { addToChainAfter, Handler, HasOnSuccess } from "@insite/client-framework/HandlerCreator";
import {
    chain,
    WaitForData,
} from "@insite/client-framework/Store/Pages/MyListDetails/Handlers/LoadWishListLines";
import { WishListLineModel } from "@insite/client-framework/Types/ApiModels";
import { MGBW_IS_CONFIGURABLE } from "@tSurya/Common/MgbwPropertyKeys";

type HandlerType = Handler<
    HasOnSuccess,
    {
        wishListLines?: WishListLineModel[];
        productInfosByWishListLineId: SafeDictionary<ProductInfo>;
    }
>;

/**
 * Real-time pricing does not apply for MGBW configurator products. The backend persists the
 * configurator price on the wish list line itself (via the saved configurator selections), so for
 * configurator lines we override the product info price - clobbered by LoadRealTimePrices - with the
 * price already present on the wish list line.
 */
export const OverrideConfiguratorPrices: HandlerType = props => {
    const { wishListLines, productInfosByWishListLineId } = props;
    if (!wishListLines?.length) {
        return;
    }

    wishListLines.forEach(wishListLine => {
        const isConfiguratorProduct = wishListLine.properties?.[MGBW_IS_CONFIGURABLE] === "true";
        if (!isConfiguratorProduct || !wishListLine.pricing) {
            return;
        }

        const productInfo = productInfosByWishListLineId[wishListLine.id];
        if (productInfo) {
            productInfo.pricing = wishListLine.pricing;
            productInfo.failedToLoadPricing = undefined;
        }
    });
};

addToChainAfter(chain, WaitForData, OverrideConfiguratorPrices);
